import log from 'salvo-lite/log'
import AjaxCart from '../helpers/AjaxCart'
import Swiper, { Pagination, A11y, Thumbs } from 'swiper'

// handle product page popups
function popupSizeguide () {
    document.getElementById('popupSizeguide').style.opacity = 1
    document.getElementById('popupSizeguide').style.visibility = 'visible'
}

function popupAddtoBag () {
    document.getElementById('popupAddtoBag').style.opacity = 1
    document.getElementById('popupAddtoBag').style.visibility = 'visible'
}

function closePopups () {
    for (var i = document.getElementsByClassName('popup').length - 1; i >= 0; i--) {
        document.getElementsByClassName('popup')[i].style.opacity = 0
        document.getElementsByClassName('popup')[i].style.visibility = 'hidden'
    }
}

/* scroll to top
function scrollToTop () {
    window.scrollTo(0, 0)
} */

// play and pause for product videos
for (var i = document.getElementsByClassName('productVideo').length - 1; i >= 0; i--) {
    var video = document.getElementsByClassName('productVideo')[i]
    var videoID = document.getElementsByClassName('productVideo')[i].id
    video.addEventListener('click', (e) => {
        if (video.paused || video.ended) {
            video.play()
            document.getElementById(videoID + 'play').style.display = 'none'
        } else {
            video.pause()
            document.getElementById(videoID + 'play').style.display = 'block'
        }
    })
}

function productGallery () {
    // gallery with image zoom
    // carousel modified from ... somewhere!
    // zoom modified from http://malaman.github.io/js-image-zoom/package/js-image-zoom.js
    // !(function (d) {
    var itemClassName = 'gallery__photo'
    var items = document.getElementsByClassName(itemClassName)
    var totalItems = items.length
    var slide = 0
    var moving = true
    var touchstartX = 0
    var touchendX = 0
    var gallery = document.getElementsByClassName('gallery')[0]
    var widthAdjust = 0

    if (screen.width >= 769) {
        widthAdjust = document.getElementsByClassName('gallery')[0].dataset.width - 1
    } else {
        //
    }

    function checkWindowSize () {
        if (window.innerWidth <= 769 && document.getElementsByClassName('gallery__photo active')[1]) {
            document.getElementsByClassName('gallery__photo active')[1].classList.remove('active')
        } else {
            items[0 + widthAdjust].classList.add('active')
        }
    }
    window.onresize = checkWindowSize

    function setInitialClasses () {
        // items[0].classList.add('active')
        items[0 + widthAdjust].classList.add('active')
        items[1 + widthAdjust].classList.add('next')
    }

    function setEventListeners () {
        var next = document.getElementsByClassName('gallery__button--next')[0]
        var prev = document.getElementsByClassName('gallery__button--prev')[0]
        var zoomedOut = true
        next.addEventListener('click', moveNext)
        prev.addEventListener('click', movePrev)
        gallery.addEventListener('touchstart', e => {
            touchstartX = e.changedTouches[0].screenX
            if (window.visualViewport.scale !== 1) {
                zoomedOut = false
            } else {
                zoomedOut = true
            }
        })
        gallery.addEventListener('touchend', e => {
            touchendX = e.changedTouches[0].screenX
            if (window.visualViewport.scale !== 1) {
                zoomedOut = false
            }
            if (e.touches.length < 2 && zoomedOut) {
                swipegallery(touchendX, touchstartX)
            }
        })
        for (var i = document.getElementsByClassName('gallery__thumb').length - 1; i >= 0; i--) {
            document.getElementsByClassName('gallery__thumb')[i].addEventListener('click', () => jumpTo(event.target.dataset.index))
        }
        if (screen.width >= 769) {
            for (var j = document.getElementsByClassName('gallery__photo active').length - 1; j >= 0; j--) {
                ImageZoom(document.getElementsByClassName('gallery__photo active')[j])
            }
        }
    }

    function swipegallery (touchendX, touchstartX) {
        if (touchendX < touchstartX) moveNext()
        if (touchendX > touchstartX) movePrev()
    }

    function disableInteraction () {
        moving = true
        setTimeout(function () {
            moving = false
        }, 500)
    }

    function movegalleryTo () {
        var next = document.getElementsByClassName('gallery__button--next')[0]
        var prev = document.getElementsByClassName('gallery__button--prev')[0]
        if (!moving) { // Check if gallery is moving, if not, allow interaction
            disableInteraction() // temporarily disable interactivity
            if ((Number(widthAdjust) + Number(slide)) >= (totalItems)) {
                slide = (slide - widthAdjust)
            }
            var newPrevious = slide - 1
            var newNext = newPrevious + 2
            if (slide === 0) {
                prev.style.display = 'none'
                next.style.display = 'block'
                newPrevious = (totalItems - 1)
            } else if (Number(slide) + Number(widthAdjust) === (totalItems - 1)) {
                newNext = 0
                next.style.display = 'none'
                prev.style.display = 'block'
            } else {
                next.style.display = 'block'
                prev.style.display = 'block'
            }

            // reset to default classes.
            for (var i = items.length - 1; i >= 0; i--) {
                items[i].className = itemClassName
            }

            // Add the new classes
            items[slide].classList.add('active')
            items[newPrevious].classList.add('prev')
            if (slide + widthAdjust === (totalItems - 1)) { // last item
                items[0].classList.add('next')
            } else {
                items[widthAdjust + newNext].classList.add('next')
            }

            if (widthAdjust === 1) {
                // var additionalSlide = parseInt(slide + widthAdjust)
                items[parseInt(slide + widthAdjust)].classList.add('active') // 0 forces addition rather than concatenation
                ImageZoom(items[parseInt(slide + widthAdjust)])
                document.getElementsByClassName('gallery__photo active')[0].classList.add('left')
                document.getElementsByClassName('gallery__photo active')[1].classList.add('right')
            }
            ImageZoom(items[slide])
        }
    }

    function jumpTo (newSlide) {
        slide = parseInt(newSlide)
        movegalleryTo(slide)
    }

    function moveNext () {
        // Check if moving
        if (!moving) {
            // If it's the last slide do nothing else +1
            if (slide === (totalItems - 1)) {
                return
            } else {
                slide++
            }
            for (var i = document.getElementsByClassName('gallery__photo').length - 1; i >= 0; i--) {
                document.getElementsByClassName('gallery__photo')[i].classList.add('prev')
            } // this was an attempt to fix transition?
            movegalleryTo(slide)
        }
    }

    function movePrev () {
        // Check if moving
        if (!moving) {
            // If it's the first slide do nothing else -1
            if (slide === 0) {
                return
            } else {
                slide--
            }
            for (var i = document.getElementsByClassName('gallery__photo').length - 1; i >= 0; i--) {
                document.getElementsByClassName('gallery__photo')[i].classList.add('next')
            } // this was an attempt to fix transition?
            movegalleryTo(slide)
        }
    }

    // Initialise gallery
    function initgallery () {
        setInitialClasses()
        setEventListeners()
        // Set moving to false now that the gallery is ready
        moving = false
    }

    function ImageZoom (image) {
        // alert('zooming image: ' + image.currentSrc)
        'use strict'
        var container = image.parentElement
        var touchable = false
        var options = {}
        var data = {
            sourceImg: {
                element: null,
                width: 0,
                height: 0,
                naturalWidth: 0,
                naturalHeight: 0
            },
            zoomedImg: {
                element: null,
                width: 0,
                height: 0
            },
            zoomLens: {
                element: null,
                width: 0,
                height: 0
            }
        }
        var div = document.createElement('div')
        var lensDiv = document.createElement('div')
        var scaleX
        var scaleY
        var offset

        function getOffset (el) {
            var elRect = 0
            if (el.classList.contains('left')) {
                // setTimeout(function(){
                elRect = el.getBoundingClientRect()
                return {
                    left: elRect.left,
                    top: elRect.top
                }
                // }, 5000)
            } else if (el.classList.contains('right')) {
                // setTimeout(function(){
                elRect = el.getBoundingClientRect()
                return {
                    left: elRect.left,
                    top: elRect.top
                }
                // }, 5000)
            } else {
                return {
                    left: 0,
                    top: 0
                }
            }
        }

        function leftLimit (min) {
            return options.width - min
        }

        function topLimit (min) {
            return options.height - min
        }

        function getValue (val, min, max) {
            return val < min ? min : val > max ? max : val
        }

        function getPosition (v, min, max) {
            var value = getValue(v, min, max)
            return value - min
        }

        function zoomLensLeft (left) {
            var leftMin = data.zoomLens.width / 2
            return getPosition(left, leftMin, leftLimit(leftMin))
        }

        function zoomLensTop (top) {
            var topMin = data.zoomLens.height / 2
            return getPosition(top, topMin, topLimit(topMin))
        }

        function onSourceImgLoad () {
            options.height = data.sourceImg.element.height
            options.width = data.sourceImg.element.width
            data.zoomedImg.element.style.width = 'calc(100% - 2px)'
            data.zoomedImg.element.style.height = 'calc(100% - 2px)'
            data.sourceImg.naturalWidth = data.sourceImg.element.naturalWidth
            data.sourceImg.naturalHeight = data.sourceImg.element.naturalHeight
            data.zoomedImg.element.style.backgroundSize = data.sourceImg.naturalWidth + 'px ' + data.sourceImg.naturalHeight + 'px'
            scaleX = data.sourceImg.naturalWidth / options.width
            scaleY = data.sourceImg.naturalHeight / options.height
            offset = getOffset(data.sourceImg.element)
            data.zoomedImg.element.style.display = 'block'
            data.zoomLens.width = data.zoomedImg.element.clientWidth / scaleX
            data.zoomLens.height = data.zoomedImg.element.clientHeight / scaleY
            data.zoomedImg.element.style.display = 'none'
            data.zoomLens.element.style.position = 'absolute'
            data.zoomLens.element.style.width = data.zoomLens.width + 'px'
            data.zoomLens.element.style.height = data.zoomLens.height + 'px'
            data.zoomLens.element.pointerEvents = 'none'
        }

        function setup () {
            for (var i = container.getElementsByClassName('product-zoom__zoomed-image').length - 1; i >= 0; i--) {
                container.getElementsByClassName('product-zoom__zoomed-image')[i].remove()
                container.getElementsByClassName('product-zoom__zoomed-area')[i].remove()
            }
            data.sourceImg.element = image
            options = options || {}
            container.style.position = 'relative'
            data.zoomLens.element = container.appendChild(lensDiv)
            data.zoomLens.element.style.display = 'none'
            data.zoomLens.element.classList.add('product-zoom__zoomed-area')
            data.zoomedImg.element = container.appendChild(div)
            data.zoomedImg.element.classList.add('product-zoom__zoomed-image')
            data.zoomedImg.element.style.backgroundImage = 'url(' + image.dataset.zoom + ')'
            data.zoomedImg.element.style.display = 'none'
            container.addEventListener('mousemove', events, !1)
            container.addEventListener('mouseenter', events, !1)
            container.addEventListener('mouseleave', events, !1)
            data.zoomLens.element.addEventListener('mouseenter', events, !1)
            data.zoomLens.element.addEventListener('mouseleave', events, !1)
            window.addEventListener('scroll', events, !1)
            document.addEventListener('touchstart', function () {
                touchable = true
            })
            return data
        }

        var events = {
            handleEvent: function (event) {
                if (touchable === true) {
                    return false
                }
                switch (event.type) {
                case 'mousemove':
                    return this.handleMouseMove(event)
                case 'mouseenter':
                    return this.handleMouseEnter(event)
                case 'mouseleave':
                    return this.handleMouseLeave(event)
                case 'scroll':
                    return this.handleScroll(event)
                }
            },
            handleMouseMove: function (event) {
                var offsetX
                var offsetY
                var backgroundTop
                var backgroundRight
                var backgroundPosition
                if (offset) {
                    offsetX = zoomLensLeft(event.clientX - offset.left)
                    offsetY = zoomLensTop(event.clientY - offset.top)
                    backgroundTop = offsetX * scaleX
                    backgroundRight = offsetY * scaleY
                    backgroundPosition = '-' + backgroundTop + 'px ' + '-' + backgroundRight + 'px'
                    data.zoomedImg.element.style.backgroundPosition = backgroundPosition
                    data.zoomLens.element.style.cssText += 'transform:' + 'translate(' + offsetX + 'px,' + offsetY + 'px);display: block;left:0px;top:0px;'
                }
            },
            handleMouseEnter: function () {
                offset = getOffset(data.sourceImg.element) // to fix right-hand zoom
                data.zoomedImg.element.style.display = 'block'
                data.zoomLens.element.style.display = 'block'
            },
            handleMouseLeave: function () {
                data.zoomedImg.element.style.display = 'none'
                data.zoomLens.element.style.display = 'none'
            },
            handleScroll: function () {
                offset = getOffset(data.sourceImg.element)
            }
        }

        // Setup/Initialize library
        setup()

        if (data.sourceImg.element.complete) {
            onSourceImgLoad()
        } else {
            data.sourceImg.element.onload = onSourceImgLoad
        }
    }
    // make it rain
    initgallery()
    // }(document))
}

class Product {
    constructor (theme) {
        this._theme = theme
        this._popupSizeguide = document.querySelector('.popupSizeguide')
        this._popupOverlay = document.querySelectorAll('.popup__overlay')
        this._popupClose = document.querySelectorAll('.popup__close')
        this._addToCart = document.querySelectorAll('[data-add-to-cart]')
        this._popup = document.querySelector('.product__add-on')
        this._tattoo = document.querySelector('[name="properties[tattoo]"]')
        this._mainSlider = document.querySelector('[data-main-slider]')
        this._thumbSlider = document.querySelector('[data-thumbnail-slider]')
        this._addOnSlider = document.querySelector('[data-add-on-slider]')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    async onInit () {
        this._sliders()
        if (this._addToCart) {
            this._addToCart.forEach(add => {
                add.addEventListener('click', e => {
                    e.preventDefault()
                    this._add(e, add)
                })
            })
        }
        if (this._popupSizeguide) {
            this._popupSizeguide.addEventListener('click', e => {
                e.preventDefault()
                popupSizeguide()
            })
        }
        if (this._popupOverlay) {
            this._popupOverlay.forEach(popupOverlay => {
                popupOverlay.addEventListener('click', e => {
                    e.preventDefault()
                    closePopups()
                })
            })
        }
        if (this._popupClose) {
            this._popupClose.forEach(popupClose => {
                popupClose.addEventListener('click', e => {
                    e.preventDefault()
                    closePopups()
                })
            })
        }
        productGallery()
    }
    async _add (e, add) {
        const info = JSON.parse(add.getAttribute('data-add-to-cart'))
        const quantity = 1
        const selectedVariant = info.id
        const originalText = add.textContent
        add.textContent = info.adding
        let payload = ''
        // if (this._tattoo && this._tattoo.checked) {
        //    payload = {quantity, id: selectedVariant, properties: {tattoo: this._tattoo.checked}}
        // } else {
        payload = {quantity, id: selectedVariant}
        // }
        // const data = await
        AjaxCart.addItem(payload)
        /* if (this._tattoo && this._tattoo.checked) {
            let tattoo = false
            data.cart.data.items.forEach(item => {
                if (item.properties.tattoo) {
                    let sku = item.sku ? item.sku : item.id
                    if (!tattoo) {
                        tattoo = sku
                    } else {
                        tattoo += `, ${sku}`
                    }
                }
            })
            const cartPayload = {attributes: {tattoo: tattoo}}
            await AjaxCart.updateCart(cartPayload)
        } */
        add.textContent = info.added
        popupAddtoBag()
        setTimeout(() => {
            add.textContent = originalText
            if (this._popup) {
                // this._popup.classList.remove('visually-hidden')
                // document.body.classList.add('no-scroll')
            }
        }, 3000)
    }
    _sliders () {
        Swiper.use([Pagination, A11y, Thumbs])
        const thumbnails = new Swiper(this._thumbSlider, {
            // loop: true,
            slidesPerView: 7,
            spaceBetween: 10,
            watchSlidesProgress: true
            // centeredSlides: true
        })
        const mainSlider = new Swiper(this._mainSlider, {
            // loop: true,
            watchSlidesProgress: true,
            pagination: {
                el: '.swiper-pagination'
            },
            thumbs: {
                swiper: thumbnails
            },
            preventClicks: true,
            preventClicksPropagation: true
        })
        mainSlider.on('slideChange', function () {
            document.querySelectorAll('.product__media-slider video').forEach(video => {
                if (!video.paused) {
                    const evt = new Event('pauseVideo')
                    video.dispatchEvent(evt)
                    console.log('here', video)
                }
            })
        })
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Product.js